import { Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React, { Fragment } from 'react'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  content: {
    flex: 'auto'
  },
  cellText: {
    padding: 0,
    margin: 0
  },
  alignText: { textAlign: 'justify', textAlignLast: 'auto' }
}))

export const CellText: React.FC<{ text: any; textAlign?: boolean }> = ({
  text,
  textAlign
}) => {
  const classes = useStyles()

  return (
    <Fragment>
      <Typography
        className={`${classes.cellText} ${textAlign ? classes.alignText : ''}`}
        variant='body2'
        component='p'
      >
        {text}
      </Typography>
    </Fragment>
  )
}
